 angular
   .module('vppApp')
   .factory('OffersFilterService', OffersFilterService);
 OffersFilterService.$inject = ['$rootScope', 'GetOfferYears', 'CombineOffersService'];

 function OffersFilterService($rootScope, GetOfferYears, CombineOffersService) {
  var OffersFilterService = {};
  OffersFilterService.vehicles = [];

    OffersFilterService.filterOffers = function (incentives, programDetails, year) {
      OffersFilterService.vehicles.length = 0;
      var selectedOffers = year ? incentives[year] : incentives[$rootScope.selectedYear];
      var currentMake,
          currentModel,
          currentDetails,
          finDetails,
          cashDetails;

      for (var i = 0; Object.keys(selectedOffers).length > i; i++){
        currentMake = Object.keys(selectedOffers)[i];
        for (var x = 0; Object.keys(selectedOffers[currentMake]).length > x; x++){
          currentModel = Object.keys(selectedOffers[currentMake])[x];
          currentDetails = selectedOffers[currentMake][currentModel];
          finDetails= currentDetails.financeValues.details;
          cashDetails = currentDetails.cashValues.details;
          if(finDetails || cashDetails){
            CombineOffersService.combineOffers(currentMake, currentModel, currentDetails, programDetails);
          }else {
            delete selectedOffers[currentMake][currentModel];
          }
        }

      }
      // var tempArray = CombineOffersService.vehicles
      // OffersFilterService.vehicles = uniqueByKey(tempArray, 'model');
      OffersFilterService.vehicles = CombineOffersService.vehicles;
    };
  return OffersFilterService;

 }